"use strict";

const InWaves = require('../in-waves');

/**
 * The second half of the In Waves animation
 *
 * CH1 |_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|
 * CH2 |_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|
 */
class InWavesTwo extends InWaves {
  constructor() {
    super();

    const channelOneOn = [];
    const channelTwoOn = [];
    for (let ch2FrameFadeUp = this.ch2FrameFadeUpStart, ch2FrameFadeUpMultiplier = 0 ; ch2FrameFadeUp < this.ch2FrameFadeUpStart + this.fadeLength ; ch2FrameFadeUp++, ch2FrameFadeUpMultiplier++) {
      channelOneOn.push({
        frame: ch2FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch2FrameFadeUpMultiplier)
      });
      channelTwoOn.push({
        frame: ch2FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch2FrameFadeUpMultiplier)
      });
    }

    for (let ch2FrameFadeHold = this.ch2FrameFadeHoldStart ; ch2FrameFadeHold < this.ch2FrameFadeHoldStart + this.fadeLength ; ch2FrameFadeHold++) {
      channelOneOn.push({
        frame: ch2FrameFadeHold,
        brightness: 250
      });
      channelTwoOn.push({
        frame: ch2FrameFadeHold,
        brightness: 250
      });
    }

    for (let ch2FrameFadeUp = this.ch2FrameFadeDownStart, ch2FrameFadeDownMultiplier = 29 ; ch2FrameFadeUp < this.ch2FrameFadeDownStart + this.fadeLength ; ch2FrameFadeUp++, ch2FrameFadeDownMultiplier--) {
      channelOneOn.push({
        frame: ch2FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch2FrameFadeDownMultiplier)
      });
      channelTwoOn.push({
        frame: ch2FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch2FrameFadeDownMultiplier)
      });
    }

    this.channels = {
      1: channelOneOn,
      2: channelTwoOn
    };
  }

  /**
   * Get the display name for this animation
   * Used on buttons and reporting
   *
   * @returns {string}
   */
  static getDisplayName() {
    return '2nd';
  }
}

module.exports = InWavesTwo;
